/* ════ CATEGORIES (built-in + custom) ═════════════════════ */
import { state } from './state.js';
import { DEFAULT_CATS } from './config.js';

const BUILTIN = new Map(DEFAULT_CATS.map(c => [c.id, c]));
export const isBuiltin = id => BUILTIN.has(id);

// Built-ins first, then custom (sorted).
export function allCats() {
  const custom = (state.categories || []).slice()
    .sort((a, b) => (a.sort ?? 100) - (b.sort ?? 100) || String(a.name).localeCompare(String(b.name)));
  return [...DEFAULT_CATS, ...custom];
}
export const customCats = () => (state.categories || []).slice()
  .sort((a, b) => (a.sort ?? 100) - (b.sort ?? 100) || String(a.name).localeCompare(String(b.name)));

export function catById(id) {
  return BUILTIN.get(id) || (state.categories || []).find(c => c.id === id) || { id, name: id || '—', icon: '', color: '#9CA3AF' };
}
export const catLabel = id => catById(id).name;
export const catIcon = id => catById(id).icon || '';
export const catColor = id => catById(id).color || '#9CA3AF';

function toRgb(h) {
  h = String(h || '#9CA3AF').replace('#', '');
  if (h.length === 3) h = h.split('').map(x => x + x).join('');
  const n = parseInt(h, 16) || 0;
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
export function darken(hex, amt = 0.16) { const [r, g, b] = toRgb(hex); const d = v => Math.round(v * (1 - amt)); return `rgb(${d(r)},${d(g)},${d(b)})`; }
export function rgba(hex, a) { const [r, g, b] = toRgb(hex); return `rgba(${r},${g},${b},${a})`; }

// Class + inline vars used at every render site. Built-ins keep their own class
// (unchanged look); custom ones use `cat-custom` + CSS-var colours.
export const catClass = id => isBuiltin(id) ? `cat-${id}` : 'cat-custom';
export function catVars(id) {
  if (isBuiltin(id)) return '';
  const c = catColor(id);
  return `--cat:${c};--cat-bg:${rgba(c, 0.13)};--cat-bd:${rgba(c, 0.4)}`;
}
export const catGradient = id => { const c = catColor(id); return `linear-gradient(135deg, ${c}, ${darken(c)})`; };
